module.exports = __webpack_public_path__ + "img/P2-B3.565403ce.svg";